// 生成UUID的工具函数
export function generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c: string): string {
        const r: number = Math.random() * 16 | 0;
        const v: number = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

// 生成短ID（用于简单场景）
export function generateShortId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
}